import React from "react";
import "./TermsHero.css";

const TermsHero = () => {
  return (
    <section className="termsHero">
      <div className="termsHero-inner">
        <h1>Terms and conditions</h1>
        <p>
          Please read these terms carefully before using the IRQGYP website or
          engaging with our products and services. By accessing this website,
          you agree to be bound by the terms outlined below.
        </p>
        <span>Last updated: April 2026</span>
      </div>
    </section>
  );
};

export default TermsHero;
